

import React, { useState, useEffect } from 'react';
// import Sidebar from '../../components/Sidebar';
import './Bonafide.css'
import Leavdoc from './Leavdoc';
import AlertMessage from "../../AlertMessage";

import { Link } from 'react-router-dom'

const Leaving = () => {
  const [formData, setFormData] = useState({
    stdName: '',
    stdMother: '',
    religion: '',
    class: '',
    educationalYear: '',
    dob: '',
    birthPlace: '',
    registerno: '',
    reason: '',
    selectedBookNo: '',
    progress: '',
    conduct: '',
    remark: '',
    schoolLogo: '',
    schoolLogo2: '',
    documentNo: '', // Initial document number
    bookno: '',
    printdate: '',
    date: '',
    admissionClass: '',
    aparId: '',
    motherTounge: '',
    panId: '',
    sinceWhen: '',
    owtId: '',
    showOwtId: false,
    gender: '',
    stdNameEnglish: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [udiseNumber, setUdiseNumber] = useState('');
  const [lastLeavDocNo, setlastLeavDocNo] = useState(0);
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const userStatus = localStorage.getItem("userStatus");
  const isEditable = userStatus === "DKglzhgYFYTDT141414HGCkkgfs22117785YFUTFybnujghhgtghghYFYVNOmC234567Omgkysfgvghyfjhyfvv56764" || localStorage.getItem("editable") === "true";

  const [customProgress, setCustomProgress] = useState('');
  const [customConduct, setCustomConduct] = useState('');
  const [customReason, setCustomReason] = useState('');
  const [customRemark, setCustomRemark] = useState('');
  const [savedProgressOptions, setSavedProgressOptions] = useState([]);
  const [savedConductOptions, setSavedConductOptions] = useState([]);
  const [savedReasonOptions, setSavedReasonOptions] = useState([]);
  const [savedRemarkOptions, setSavedRemarkOptions] = useState([]);


  const fetchSavedOptions = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/lcSettings.json`);
      const data = await response.json();
      if (data) {
        setSavedProgressOptions(data.progress || []);
        setSavedConductOptions(data.conduct || []);
        setSavedReasonOptions(data.reason || []);
        setSavedRemarkOptions(data.remark || []);
      }
    } catch (error) {
      console.error('Error fetching saved options:', error);
    }
  };
  useEffect(() => {
    fetchSavedOptions();
  }, [udiseNumber]);

  const handleSaveCustomValue = async (field, value) => {
    try {
      // Fetch current settings first
      const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/lcSettings.json`);

      // Check if the response is okay
      if (!response.ok) {
        throw new Error('Failed to fetch current settings');
      }

      const data = await response.json();

      // Initialize data if it's null or an empty object
      const currentData = data && Object.keys(data).length > 0 ? data : {
        progress: [],
        conduct: [],
        reason: [],
        remark: [],
      };

      // Ensure each property is an array
      currentData.progress = Array.isArray(currentData.progress) ? currentData.progress : [];
      currentData.conduct = Array.isArray(currentData.conduct) ? currentData.conduct : [];
      currentData.reason = Array.isArray(currentData.reason) ? currentData.reason : [];
      currentData.remark = Array.isArray(currentData.remark) ? currentData.remark : [];

      // Prepare the updated data
      let updatedData;
      if (field === 'progress') {
        updatedData = {
          ...currentData,
          progress: [...new Set([...currentData.progress, value])], // Append the new value to the specific field, ensuring uniqueness
        };
      } else if (field === 'conduct') {
        updatedData = {
          ...currentData,
          conduct: [...new Set([...currentData.conduct, value])], // Append the new value to the specific field, ensuring uniqueness
        };
      } else if (field === 'reason') {
        updatedData = {
          ...currentData,
          reason: [...new Set([...currentData.reason, value])], // Append the new value to the specific field, ensuring uniqueness
        };
      } else if (field === 'remark') {
        updatedData = {
          ...currentData,
          remark: [...new Set([...currentData.remark, value])], // Append the new value to the specific field, ensuring uniqueness
        };
      }

      // Save the updated settings back to Firebase
      const saveResponse = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/lcSettings.json`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedData),
      });

      if (!saveResponse.ok) {
        throw new Error('Failed to save custom value');
      }

      // Clear the input field after saving
      if (field === 'progress') {
        setCustomProgress('');
      } else if (field === 'conduct') {
        setCustomConduct('');
      } else if (field === 'reason') {
        setCustomReason('');
      } else if (field === 'remark') {
        setCustomRemark('');
      }

      setAlertMessage("Saved Successfully");
      fetchSavedOptions(); // Refresh the saved options
    } catch (error) {
      console.error('Error saving custom value:', error);
      setAlertMessage('An error occurred while saving the custom value.'); // Optional: Show an alert message
    }
  };


  const handleDeleteCustomValue = async (field, value) => {
    try {
      // Fetch current settings first
      const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/lcSettings.json`);

      if (!response.ok) {
        throw new Error('Failed to fetch current settings');
      }
      const data = await response.json();
      const currentData = data || {
        progress: [],
        conduct: [],
        reason: [],
        remark: [],
      };
      // Remove the value from the specific field
      if (field === 'progress') {
        currentData.progress = currentData.progress.filter(item => item !== value);
      } else if (field === 'conduct') {
        currentData.conduct = currentData.conduct.filter(item => item !== value);
      } else if (field === 'reason') {
        currentData.reason = currentData.reason.filter(item => item !== value);
      } else if (field === 'remark') {
        currentData.remark = currentData.remark.filter(item => item !== value);
      }
      // Save the updated settings back to Firebase
      const saveResponse = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/lcSettings.json`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(currentData),
      });
      if (!saveResponse.ok) {
        throw new Error('Failed to delete custom value');
      }
      setAlertMessage("Deleted Successfully");
      fetchSavedOptions(); // Refresh the saved options
    } catch (error) {
      console.error('Error deleting custom value:', error);
      setAlertMessage('An error occurred while deleting the custom value.'); // Optional: Show an alert message
    }
  };


  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') || 'English';
    setLanguage(storedLanguage);
  }, []);

  useEffect(() => {
    setFormData({
      stdName: '',
      stdMother: '',
      religion: '',
      class: '',
      educationalYear: '',
      dob: '',
      birthPlace: '',
      registerno: '',
      reason: language === 'English' ? 'Graduated' : 'इतरत्र जात आहे',
      selectedBookNo: '',
      progress: language === 'English' ? 'Excellent' : 'उत्कृष्ट',
      conduct: language === 'English' ? 'Excellent' : 'उत्कृष्ट',
      remark: language === 'English' ? 'Going Elsewhere' : 'इतरत्र जात आहे',
      schoolLogo: '',
      schoolLogo2: '',
      documentNo: '', // Initial document number
      bookno: '',
      printdate: '',
      date: '',
      admissionClass: '',
      aparId: '',
      motherTounge: '',
      panId: '',
      sinceWhen: '',
      owtId: '',
      showOwtId: false,
      gender: '',
      stdNameEnglish: '',
    });
  }, [language]);


  useEffect(() => {
    const schoolUdiseNumber = localStorage.getItem("udiseNumber");
    if (schoolUdiseNumber) {
      setUdiseNumber(schoolUdiseNumber)
    }
  }, [])


  useEffect(() => {
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`; // Format date as yyyy-MM-dd
    setFormData(prevData => ({ ...prevData, printdate: formattedDate, date: formattedDate }));
  }, []);

  const [duplicateStudents, setDuplicateStudents] = useState([]);
  const [showDuplicatePopup, setShowDuplicatePopup] = useState(false);
  const [isStudentActive, setIsStudentActive] = useState(true);

  const handleSelectStudent = (selectedStudent) => {
    setFormData((prevData) => ({
      ...prevData,
      stdName: selectedStudent.stdName || '',
      stdMother: selectedStudent.stdMother || '',
      religion: selectedStudent.religion || '',
      class: selectedStudent.currentClass || '',
      educationalYear: selectedStudent.educationalYear || '',
      dob: selectedStudent.dob || '',
      birthPlace: selectedStudent.birthPlace || '',
      dobInWords: selectedStudent.dobInWords || '',
      studentId: selectedStudent.studentId || '',
      stdSurname: selectedStudent.stdSurname || '',
      stdFather: selectedStudent.stdFather || '',
      stdAdharNo: selectedStudent.stdAdharNo || '',
      division: selectedStudent.division || '',
      bookno: selectedStudent.bookno || '',
      admissionClass: selectedStudent.admissionClass || '',
      aparId: selectedStudent.aparId || '',
      motherTounge: selectedStudent.motherTounge || '',
      panId: selectedStudent.panId || '',
      gender: selectedStudent.gender || '',

    }));
    setIsStudentActive(selectedStudent.isActive !== false);
    updateFormWithStudentData(selectedStudent);
    setShowDuplicatePopup(false);
  };

  const fetchStudentBySerialNo = async (serialNo) => {
    try {
      console.log("Fetching student for serialNo:", serialNo);
      const request = indexedDB.open('SchoolManagementDB', 1);
      return new Promise((resolve, reject) => {
        request.onsuccess = (event) => {
          const db = event.target.result;
          const transaction = db.transaction(['studentData'], 'readonly');
          const objectStore = transaction.objectStore('studentData');
          const getAllRequest = objectStore.getAll();

          getAllRequest.onsuccess = (event) => {
            const students = event.target.result;
            console.log("All students in studentData store:", students);
            if (!Array.isArray(students)) {
              console.error("Students data is not an array:", students);
              resolve(null);
              return;
            }
            const student = students.find((s) => String(s.serialNo) === String(serialNo));
            console.log("Found student for serialNo", serialNo, ":", student);
            resolve(student || null);
          };
          getAllRequest.onerror = (event) => {
            console.error("Error fetching student data:", event.target.error);
            reject(event.target.error);
          };
        };
        request.onerror = (event) => {
          console.error("Error opening IndexedDB:", event.target.error);
          reject(event.target.error);
        };
      });
    } catch (error) {
      console.error("Error in fetchStudentBySerialNo:", error);
      return null;
    }
  };

  useEffect(() => {
    const savedSerialNo = localStorage.getItem("selectedStudentSerialNo");
    if (savedSerialNo) {
      fetchStudentBySerialNo(savedSerialNo).then((studentData) => {
        console.log("Fetched student data for serialNo", savedSerialNo, ":", studentData);
        if (studentData) {
          setFormData({
            stdName: studentData.stdName || '',
            stdMother: studentData.stdMother || '',
            religion: studentData.religion || '',
            class: studentData.currentClass || '',
            educationalYear: studentData.educationalYear || '',
            dob: studentData.dob || '',
            birthPlace: studentData.birthPlace || '',
            dobInWords: studentData.dobInWords || '',
            registerno: studentData.registerNo || '',
            prevSchool: studentData.prevSchool || '',
            prevClass: studentData.prevClass || '',
            studentId: studentData.studentId || '',
            stdSurname: studentData.stdSurname || '',
            stdFather: studentData.stdFather || '',
            stdAdharNo: studentData.stdAdharNo || '',
            caste: studentData.caste || '',
            subCaste: studentData.subCaste || '',
            dateOfAdmission: studentData.dateOfAdmission || '',
            nationality: studentData.nationality || '',
            serialNo: studentData.serialNo || '',
            division: studentData.division || '',
            reason: language === 'English' ? 'Graduated' : 'पदवी प्राप्त केली',
            selectedBookNo: '',
            progress: language === 'English' ? 'Excellent' : 'उत्कृष्ट',
            conduct: language === 'English' ? 'Excellent' : 'उत्कृष्ट',
            remark: language === 'English' ? 'Going Elsewhere' : 'इतरत्र जात आहे',
            documentNo: '',
            bookno: studentData.bookno || '',
            printdate: formData.printdate || '',
            date: formData.date || '',
            admissionClass: studentData.admissionClass || '',
            aparId: studentData.aparId || '',
            motherTounge: studentData.motherTounge || '',
            panId: studentData.panId || '',
            sinceWhen: '',
            owtId: formData.owtId || '',
            gender: studentData.gender || '',
            stdNameEnglish: ''
          });
          setSearchInput(`${studentData.stdName || ''} ${studentData.stdFather || ''} ${studentData.stdSurname || ''}`.trim());
          setIsStudentActive(studentData.isActive !== false);
        } else {
          setAlertMessage(language === "English" ? "No student found ." : " विद्यार्थी सापडला नाही.");
        }
      });
    }
  }, [language]);

  const updateFormWithStudentData = (studentData) => {
    setFormData((prevData) => ({
      ...prevData,
      stdName: studentData.stdName || '',
      stdMother: studentData.stdMother || '',
      religion: studentData.religion || '',
      class: studentData.currentClass || '',
      educationalYear: studentData.educationalYear || '',
      dob: studentData.dob || '',
      birthPlace: studentData.birthPlace || '',
      dobInWords: studentData.dobInWords || '',
      studentId: studentData.studentId || '',
      stdSurname: studentData.stdSurname || '',
      stdFather: studentData.stdFather || '',
      stdAdharNo: studentData.stdAdharNo || '',
      caste: studentData.caste || '',
      subCaste: studentData.subCaste || '',
      prevSchool: studentData.prevSchool || '',
      prevClass: studentData.prevClass || '',
      dateOfAdmission: studentData.dateOfAdmission || '',
      nationality: studentData.nationality || '',
      serialNo: studentData.serialNo || '',
      bookno: studentData.bookno || '',
      registerno: studentData.registerNo || '', // Make sure register number is updated
      division: studentData.division || '',
      admissionClass: studentData.admissionClass || '',
      aparId: studentData.aparId || '',
      motherTounge: studentData.motherTounge || '',
      panId: studentData.panId || '',
      progress: language === "English" ? "Excellent" : "उत्कृष्ट",
      conduct: language === "English" ? "Excellent" : "उत्कृष्ट",
      reason: language === "English" ? "Going Elsewhere" : "इतरत्र जात आहे",
      remark: language === "English" ? "Going Elsewhere" : "इतरत्र जात आहे",
      sinceWhen: '',
      owtId: '',
      gender: studentData.gender || '',
      stdNameEnglish: '',
    }));

    setSearchInput(`${studentData.stdName || ''} ${studentData.stdFather || ''} ${studentData.stdSurname || ''}`.trim());
  };

  const clearFormData = () => {
    setFormData((prevData) => ({
      ...prevData,
      stdName: '',
      stdMother: '',
      religion: '',
      class: '',
      educationalYear: '',
      dob: '',
      birthPlace: '',
      dobInWords: '',
      studentId: '',
      stdSurname: '',
      stdFather: '',
      stdAdharNo: '',
      caste: '',
      subCaste: '',
      prevSchool: '',
      prevClass: '',
      dateOfAdmission: '',
      nationality: '',
      serialNo: '',
      bookno: '',
      registerno: '',
      division: '',
      admissionClass: '',
      aparId: '',
      motherTounge: '',
      panId: '',
      gender: '',
      stdNameEnglish: '',
    }));
    setSearchInput('');
  };




  const handleChange = async (event) => {
    const { name, value } = event.target;

    setFormData((prevData) => ({ ...prevData, [name]: value }));
    if (name === 'date' || name === 'printdate') {
      const date = new Date(value);
      const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      setFormData((prevData) => ({ ...prevData, [name]: formattedDate }));
    }

    if (name === 'stdName') {
      setSearchInput(value);

      if (!value.trim()) {
        clearFormData();
        return;
      }

      if (formData.registerno) {
        return;
      }

      try {
        const request = indexedDB.open('SchoolManagementDB', 1);
        request.onsuccess = async (event) => {
          const db = event.target.result;
          const transaction = db.transaction(['studentData'], 'readonly');
          const objectStore = transaction.objectStore('studentData');
          const studentRequest = objectStore.getAll(); // Fetch all student records

          studentRequest.onsuccess = async (event) => {
            const data = event.target.result;


            if (data && typeof data === 'object') {
              const matchingStudents = [];

              Object.values(data).forEach((studentData) => {
                if (studentData) {
                  const fullName = `${studentData.stdName || ''} ${studentData.stdFather || ''} ${studentData.stdSurname || ''}`.toLowerCase();
                  if (fullName.includes(value.toLowerCase())) {
                    matchingStudents.push(studentData);
                  }
                }
              });

              if (matchingStudents.length > 1) {
                setDuplicateStudents(matchingStudents);
                setShowDuplicatePopup(true);
              } else if (matchingStudents.length === 1) {
                updateFormWithStudentData(matchingStudents[0]);
                setIsStudentActive(matchingStudents[0].isActive !== false);
              }
            }

          };

          studentRequest.onerror = (event) => {
            console.error("Error fetching student data from IndexedDB:", event.target.error);
          };
        };




        request.onerror = (event) => {
          console.error("Error opening IndexedDB:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    } else if (name === 'registerno') {
      // Only clear form data if the input is empty
      if (!value.trim()) {
        clearFormData();
        return;
      }

      // Fetch matching students from IndexedDB
      try {
        const request = indexedDB.open('SchoolManagementDB', 1);
        request.onsuccess = async (event) => {
          const db = event.target.result;
          const transaction = db.transaction(['studentData'], 'readonly');
          const objectStore = transaction.objectStore('studentData');
          const studentRequest = objectStore.getAll();

          studentRequest.onsuccess = async (event) => {
            const data = event.target.result;
            if (data && typeof data === 'object') {
              const matchingStudents = [];
              Object.values(data).forEach((serialData) => {
                if (serialData && serialData.registerNo === value) {
                  matchingStudents.push(serialData);
                }
              });

              if (matchingStudents.length >= 1) {
                const selectedStudent = matchingStudents.find(s => s.isActive !== false) || matchingStudents[0];
                updateFormWithStudentData(selectedStudent);
                setIsStudentActive(selectedStudent.isActive !== false);
              } else {
                console.log('No matching student found for register number:', value);
              }
            }
          };

          studentRequest.onerror = (event) => {
            console.error("Error fetching student data from IndexedDB:", event.target.error);
          };
        };

        request.onerror = (event) => {
          console.error("Error opening IndexedDB:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  };
  const DuplicateStudentPopup = ({ duplicateStudents, onSelectStudent }) => {
    return (
      <div className="popup">
        <h4>{language === "English" ? "Select Student" : "विद्यार्थी निवडा"}</h4>
        <table className="student-table">
          <thead>
            <tr>
              <th>{language === "English" ? "Full Name" : "पूर्ण नाव"}</th>
              <th>{language === "English" ? "Class" : "वर्ग"}</th>
              <th>{language === "English" ? "Register No " : "नोंदणी क्र."}</th>
            </tr>
          </thead>
          <tbody>
            {duplicateStudents.map((student, index) => (
              <tr key={index} onClick={() => onSelectStudent(student)}>
                <td>{`${student.stdName || ''} ${student.stdFather || ''} ${student.stdSurname || ''}`}</td>
                <td>{student.currentClass}</td>
                <td>{student.registerNo}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };


  useEffect(() => {
    const fetchlastLeavDocNo = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/lastLeavDocNo.json`);
        if (!response.ok) {
          throw new Error('Failed to fetch last document number');
        }
        const data = await response.json();
        setlastLeavDocNo(data || 0);
      } catch (error) {
        console.error('Error fetching last document number:', error);
      }
    };
    fetchlastLeavDocNo();
  }, [udiseNumber]);


  const handleSubmit = async (event) => {
    event.preventDefault();

    // Check if required fields are filled
    if (!formData.registerno || !formData.stdName) {
      setAlertMessage('Please fill in all required fields before submitting.');
      return;
    }

    try {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version

      request.onsuccess = async (event) => {
        const db = event.target.result;
        const transaction = db.transaction(['studentData'], 'readonly');
        const objectStore = transaction.objectStore('studentData');
        const studentRequest = objectStore.getAll(); // Fetch all student records

        studentRequest.onsuccess = async (event) => {
          const data = event.target.result;

          // Check if data is not null and is an object
          if (data && Array.isArray(data)) {
            let serialNo = null;

            // Iterate over each student record
            data.forEach((studentData) => {
              if (studentData && studentData.registerNo === formData.registerno) {
                serialNo = studentData.serialNo; // Set the serialNo
              }
            });

            // If a matching serialNo is found, proceed to update Firebase
            if (serialNo) {
              // Fetch the document number
              const lastLeavDocNoResponse = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/lastLeavDocumentNo.json`);
              if (!lastLeavDocNoResponse.ok) {
                throw new Error('Failed to fetch lastLeavDocNo');
              }
              const documentNo = await lastLeavDocNoResponse.json();

              // Update the leavingCertificate node with serialNo
              await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/leavingCertificate/${serialNo}/${documentNo}.json`, {
                method: 'PATCH', // Use PATCH method to update specific fields
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({ date: new Date().toLocaleDateString() }), // Update with the current date
              });

              // Increment the document number
              const newDocumentNo = documentNo + 1;

              // Update lastLeavDocNo in Firebase
              const lastSerialUpdateResponse = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}.json`, {
                method: 'PATCH',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({ lastLeavDocNo: newDocumentNo }),
              });
              if (!lastSerialUpdateResponse.ok) {
                throw new Error('Failed to update lastLeavDocNo');
              }

              // Update formData with newDocumentNo
              setFormData(prevData => ({ ...prevData, documentNo: newDocumentNo }));
              setSubmitted(true);
            } else {
              console.error('No matching serialNo found for the registerNo:', formData.registerno);
              setAlertMessage('No matching student found for the provided register number.');
            }
          } else {
            console.error('Data fetched is not valid:', data);
            setAlertMessage('No student data found.');
          }
        };

        studentRequest.onerror = (event) => {
          console.error("Error fetching student data from IndexedDB:", event.target.error);
        };
      };

      request.onerror = (event) => {
        console.error("Error opening IndexedDB:", event.target.error);
      };
    } catch (error) {
      console.error("Error handling submit:", error);
      setAlertMessage('An error occurred while submitting the form.');
    }
  };


  const [searchInput, setSearchInput] = useState('');

  const [isProgressOther, setIsProgressOther] = useState(formData.progress === (language === "English" ? "Other" : "इतर"));
  const [isConductOther, setIsConductOther] = useState(formData.conduct === (language === "English" ? "Other" : "इतर"));
  const [isReasonOther, setIsReasonOther] = useState(formData.reason === (language === "English" ? "Other" : "इतर"));
  const [isRemarkOther, setIsRemarkOther] = useState(formData.remark === (language === "English" ? "Other" : "इतर"));

  // Handle select change for each field
  const handleSelectChange = (event, field) => {
    const { name, value } = event.target;
    if (name === "progress") {
      setIsProgressOther(value === (language === "English" ? "Other" : "इतर"));
    } else if (name === "conduct") {
      setIsConductOther(value === (language === "English" ? "Other" : "इतर"));
    } else if (name === "reason") {
      setIsReasonOther(value === (language === "English" ? "Other" : "इतर"));
    } else if (name === "remark") {
      setIsRemarkOther(value === (language === "English" ? "Other" : "इतर"));
    }
    handleChange(event);
  };

  useEffect(() => {
    const fetchOutwardIds = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/outwardIds.json`);
        if (!response.ok) {
          throw new Error('Failed to fetch outward IDs');
        }
        const data = await response.json();

        if (data) {
          setFormData(prevData => ({
            ...prevData,
            owtId: data.current + 1
          }));
        }

      } catch (error) {
        console.error('Error fetching outward IDs:', error);
      }
    };
    if (udiseNumber) {
      fetchOutwardIds();
    }
  }, [udiseNumber]);



  return (
    <div>
      <AlertMessage message={alertMessage} show={showAlert} />
      <div className='main-content-of-page leavingcer-hor-width Bonafide-Css' style={{ width: "90%", overflowX: "auto" }}>
        <div className='bonafidecontent '  >
          <h3 className='text-center mb-2' style={{ color: '#03365e', fontWeight: '600' }}>{language === "English" ? "Leaving Certificate " : "शाळा सोडल्याचा दाखला"} </h3>
          {!isStudentActive && (
            <div className="alert alert-warning" style={{ marginBottom: '-10px', fontSize: '14px', padding: '10px' }}>
              {language === "English"
                ? "This student is inactive. Please activate the student to print the Leaving Certificate."
                : "हा विद्यार्थी निष्क्रिय आहे. शाळा सोडल्याचा दाखला प्रिंट करण्यासाठी कृपया विद्यार्थ्याला सक्रिय करा."}
              <br /> <Link
                to={`/student-register/?serialNo=${formData.serialNo}`}
              >
                {language === "English" ? "Edit Student Information" : "विद्यार्थी माहिती संपादित करा"}
              </Link>
            </div>
          )}
          <div className="form-output pb-3">
            <form onSubmit={handleSubmit}>
              <br />

              <div className="form-group l3">
                <label>{language === "English" ? "Register No " : "रजिस्टर क्र."}</label>
                <input style={{ marginRight: '42px' }} className="input-field" type="text" name="registerno" value={formData.registerno} onChange={handleChange} required />
              </div>
              <br />
              <div className="form-group l3">
                <label>{language === "English" ? "Name " : "नाव"}</label>
                <input
                  style={{ marginRight: '42px' }}
                  className="input-field"
                  type="text"
                  name="stdName"
                  value={searchInput}
                  onChange={handleChange}
                  placeholder={language === "English" ? "Search by name..." : "नावाने शोधा..."}
                  required
                  readOnly={!isEditable && formData.registerno ? true : false}
                />
              </div>
              <br />
              <div className="form-group l3">
                <label>{language === "English" ? "Student Name (English)" : "विद्यार्थ्याचे नाव (English)"}</label>
                <input
                  style={{ marginRight: '42px' }}
                  className="input-field"
                  type="text"
                  name="stdNameEnglish"
                  value={formData.stdNameEnglish}
                  onChange={handleChange}
                  placeholder={language === "English" ? "Enter English Name" : "इंग्रजी नाव टाका"}
                  readOnly={!isEditable}
                />
              </div>
              <br />

              <div className="form-group l3">
                <label>{language === "English" ? "Class " : "वर्ग"}</label>
                <input style={{ marginRight: '42px' }} className="input-field" type="text" name="class" value={formData.class} onChange={handleChange} required />
              </div>
              <br />

              <div className="form-group l3">
                <label>{language === "English" ? "Since When" : "कधीपासून"}</label>
                <input style={{ marginRight: '42px' }} className="input-field" type="text" name="sinceWhen" value={formData.sinceWhen}
                  onChange={handleChange} required />
              </div>


              <br />
              <div className="form-group l1">
                <label>{language === "English" ? "Progress" : "प्रगती"}</label>
                <select
                  className="input-field"
                  name="progress"
                  value={isProgressOther ? "Other" : formData.progress}
                  onChange={(e) => handleSelectChange(e, "progress")}
                  required
                >
                  <option value={language === "English" ? "Excellent" : "उत्कृष्ट"}>
                    {language === "English" ? "Excellent" : "उत्कृष्ट"}
                  </option>
                  <option value={language === "English" ? "Good" : "चांगली"}>
                    {language === "English" ? "Good" : "चांगली"}
                  </option>
                  <option value={language === "English" ? "Satisfactory" : "समाधानकारक"}>
                    {language === "English" ? "Satisfactory" : "समाधानकारक"}
                  </option>
                  {savedProgressOptions.map((option, index) => (
                    <option key={index} value={option}>{option}</option>
                  ))}
                  <option value={language === "English" ? "Other" : "इतर"}>
                    {language === "English" ? "Other" : "इतर"}
                  </option>
                </select>

                {isProgressOther && (
                  <div style={{ marginTop: '10px', marginLeft: '105px', maxWidth: '420px' }}>
                    <input
                      className="input-field"
                      value={customProgress}
                      onChange={(e) => setCustomProgress(e.target.value)}
                    />
                    <button style={{ padding: '3px 6px', marginTop: '5px', fontSize: '14px' }} onClick={() => handleSaveCustomValue('progress', customProgress)}>Save</button>
                  </div>
                )}

                {savedProgressOptions.includes(formData.progress) && (
                  <div style={{ marginTop: '-42px', marginLeft: '90%', padding: '5px' }}>
                    <button onClick={() => handleDeleteCustomValue('progress', formData.progress)} style={{ color: 'red', padding: '2px 6px', margin: '2px 6px', backgroundColor: 'transparent' }}>
                      ✖
                    </button>
                  </div>
                )}
              </div>

              <br />

              <div className="form-group l1">
                <label>{language === "English" ? "Conduct" : "वर्तणूक"}</label>
                <select
                  className="input-field"
                  name="conduct"
                  value={isConductOther ? "Other" : formData.conduct} // Keep "Other" selected if the input is active
                  onChange={(e) => handleSelectChange(e, "conduct")}
                  required
                >
                  <option value={language === "English" ? "Excellent" : "उत्कृष्ट"}>
                    {language === "English" ? "Excellent" : "उत्कृष्ट"}
                  </option>
                  <option value={language === "English" ? "Good" : "चांगली"}>
                    {language === "English" ? "Good" : "चांगली"}
                  </option>
                  <option value={language === "English" ? "Satisfactory" : "समाधानकारक"}>
                    {language === "English" ? "Satisfactory" : "समाधानकारक"}
                  </option>

                  {savedConductOptions.map((option, index) => (
                    <option key={index} value={option}>{option}</option>
                  ))}
                  <option value={language === "English" ? "Other" : "इतर"}>
                    {language === "English" ? "Other" : "इतर"}
                  </option>

                </select>

                {isConductOther && (
                  <div style={{ marginTop: '10px', marginLeft: '105px', maxWidth: '420px' }}>
                    <input
                      className="input-field"
                      value={customConduct}
                      onChange={(e) => setCustomConduct(e.target.value)}
                    />
                    <button style={{ padding: '3px 6px', marginTop: '5px', fontSize: '14px' }} onClick={() => handleSaveCustomValue('conduct', customConduct)}>Save</button>
                  </div>
                )}


                {savedConductOptions.includes(formData.conduct) && (
                  <div style={{ marginTop: '-42px', marginLeft: '90%', padding: '5px' }}>
                    <button onClick={() => handleDeleteCustomValue('conduct', formData.conduct)} style={{ color: 'red', padding: '2px 6px', margin: '2px 6px', backgroundColor: 'transparent' }}>
                      ✖
                    </button>
                  </div>
                )}


              </div>

              <br />

              <div className="form-group l1">
                <label>{language === "English" ? "Reason" : "कारण"}</label>
                <select
                  className="input-field"
                  name="reason"
                  value={isReasonOther ? "Other" : formData.reason} // Keep "Other" selected if the input is active
                  onChange={(e) => handleSelectChange(e, "reason")}
                  required
                >
                  <option value={language === "English" ? "Graduated" : "पदवी प्राप्त केली"}>
                    {language === "English" ? "Graduated" : "पदवी प्राप्त केली"}
                  </option>
                  <option value={language === "English" ? "Transferred" : "हस्तांतरित"}>
                    {language === "English" ? "Transferred" : "हस्तांतरित"}
                  </option>
                  <option value={language === "English" ? "Expelled" : "निष्कासित"}>
                    {language === "English" ? "Expelled" : "निष्कासित"}
                  </option>
                  {savedReasonOptions.map((option, index) => (
                    <option key={index} value={option}>{option}</option>
                  ))}

                  <option value={language === "English" ? "Other" : "इतर"}>
                    {language === "English" ? "Other" : "इतर"}
                  </option>
                </select>


                {isReasonOther && (
                  <div style={{ marginTop: '10px', marginLeft: '105px', maxWidth: '420px' }}>
                    <input
                      className="input-field"
                      value={customReason}
                      onChange={(e) => setCustomReason(e.target.value)}
                    />
                    <button style={{ padding: '3px 6px', marginTop: '5px', fontSize: '14px' }} onClick={() => handleSaveCustomValue('reason', customReason)}>Save</button>
                  </div>
                )}


                {savedReasonOptions.includes(formData.reason) && (
                  <div style={{ marginTop: '-42px', marginLeft: '90%', padding: '5px' }}>
                    <button onClick={() => handleDeleteCustomValue('reason', formData.reason)} style={{ color: 'red', padding: '2px 6px', margin: '2px 6px', backgroundColor: 'transparent' }}>
                      ✖
                    </button>
                  </div>
                )}

              </div>





              <br />

              <div className="form-group l1">
                <label>{language === "English" ? "Remark" : "शेरा"}</label>
                <select
                  className="input-field"
                  name="remark"
                  value={isRemarkOther ? "Other" : formData.remark} // Keep "Other" selected if the input is active
                  onChange={(e) => handleSelectChange(e, "remark")}
                  required
                >
                  <option value={language === "English" ? "Going Elsewhere" : "इतरत्र जात आहे"}>
                    {language === "English" ? "Going Elsewhere" : "इतरत्र जात आहे"}
                  </option>
                  <option value={language === "English" ? "Transferred" : "हस्तांतरित"}>
                    {language === "English" ? "Transferred" : "हस्तांतरित"}
                  </option>
                  <option value={language === "English" ? "Expelled" : "निष्कासित"}>
                    {language === "English" ? "Expelled" : "निष्कासित"}
                  </option>
                  {savedRemarkOptions.map((option, index) => (
                    <option key={index} value={option}>{option}</option>
                  ))}
                  <option value={language === "English" ? "Other" : "इतर"}>
                    {language === "English" ? "Other" : "इतर"}
                  </option>
                </select>

                {isRemarkOther && (
                  <div style={{ marginTop: '10px', marginLeft: '105px', maxWidth: '420px' }}>
                    <input
                      className="input-field"
                      value={customRemark}
                      onChange={(e) => setCustomRemark(e.target.value)}
                    />
                    <button style={{ padding: '3px 6px', marginTop: '5px', fontSize: '14px' }} onClick={() => handleSaveCustomValue('remark', customRemark)}>Save</button>
                  </div>
                )}



                {savedRemarkOptions.includes(formData.remark) && (
                  <div style={{ marginTop: '-42px', marginLeft: '90%', padding: '5px' }}>
                    <button onClick={() => handleDeleteCustomValue('remark', formData.remark)} style={{ color: 'red', padding: '2px 6px', margin: '2px 6px', backgroundColor: 'transparent' }}>
                      ✖
                    </button>
                  </div>
                )}

              </div>

              <br />

              <div className="form-group l3">
                <label>O.W. No.</label>
                <input style={{ marginRight: '42px' }} placeholder='Temporary O.W.No change, no change to the database.' className="input-field" type="text" name="owtId" value={formData.owtId}
                  onChange={handleChange} />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px', width: '100%', gap: '8px' }}>
                <input
                  type="checkbox"
                  name="showOwtId"
                  checked={formData.showOwtId === true}
                  onChange={(e) => setFormData(prev => ({ ...prev, showOwtId: e.target.checked }))}
                  style={{ margin: 0, width: '18px', height: '18px', cursor: 'pointer', flex: 'none' }}
                />
                <label style={{ fontSize: '14px', cursor: 'pointer', margin: 0, padding: 0, flex: 'none', width: 'auto', fontWeight: '500', color: '#555' }}>
                  Show O.W. No. on Certificate
                </label>
              </div>
              <style jsx>{`
  .input-field::placeholder {
    font-size: 14px; /* Adjust the size as needed */
  }
`}</style>
              <br />
              <div className="form-group mb-3">
                <label style={{ flex: 'none' }}>{language === "English" ? "Date of leaving school " : "शाळा सोडल्याची तारीख"}</label>
                <input className="input-field dt-lc" style={{ width: '200px', marginLeft: language === "English" ? '50px' : '25px' }} type="date" name="date" value={formData.date} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label style={{ flex: 'none' }}>
                  {language === "English" ? "Certificate Print Date " : "दाखला प्रिंट तारीख"}
                </label>
                <input
                  className="input-field dt-lc"
                  style={{ width: '200px', marginLeft: '60px' }}
                  type="date"
                  name="printdate"
                  value={formData.printdate}
                  onChange={handleChange}
                  required
                />
              </div>
            </form>
          </div>
          {showDuplicatePopup && (
            <div className="popup-container">
              <DuplicateStudentPopup
                duplicateStudents={duplicateStudents}
                onSelectStudent={handleSelectStudent}
              />
            </div>
          )}
        </div>
        <div className='leavedoc-doic' >
          <Leavdoc
            handleSubmit={handleSubmit}
            submitted={submitted}
            formData={formData} isStudentActive={isStudentActive}
          />
        </div>
      </div>
    </div>
  );
};

export default Leaving;